export default function responsiveIframe() {
  document.querySelectorAll('.content-pane iframe:not(.c-video__holder iframe)').forEach(iframe => {
    const wrapper = document.createElement('div');
    wrapper.className = 'c-responsive-iframe';
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  });
}
